<template lang="html">
  <div>
    <vs-button :disabled="selected.length ==0" color="danger" type="filled" small @click="del">Delete ({{selected.length}})</vs-button>
    <vs-table
      multiple
      v-model="selected"
      :data="comments.data">
      <template slot="header">
        
      </template>
      <template slot="thead">
        <vs-th>
          Comment 
        </vs-th>
        <vs-th>
          User
        </vs-th>
        <vs-th>
          Date
        </vs-th>
        
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].content">
            {{data[indextr].content}}
          </vs-td>

          <vs-td :data="data[indextr].user.name">
            {{data[indextr].user.name}}
          </vs-td>

          <vs-td :data="data[indextr].created_at">
            {{data[indextr].created_at}}
          </vs-td>

          
        </vs-tr>
      </template>
    </vs-table>
     <vs-pagination :total="comments.last_page" v-model="page"></vs-pagination>

  </div>
</template>
<script>
export default {
    data() {
        return {
             page:1,
             comments:[],
             selected:[],
        }
    },
    created() {
         this.fetchComments()
    },
     watch:{
            page(val) {
                 var page = val;
                 this.fetchComments()
            },
        },
    methods: {
        fetchComments(){
            axios.get(`${this.$apiUrl}/v2/comments/stories?page=${this.page}`).then(res=>{
                 this.comments=res.data
            })
        },
            del(){
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: `Delete Comments`,
        text: `Are you sure you want to delete the selected (${this.selected.length})?`,
        accept:this.acceptAlert
      })
      },
      acceptAlert(){
         const items=new FormData();
         items.append('items',JSON.stringify(Object.keys(this.selected).map(f=>this.selected[f].id)) )
         this.axios.post(`${this.$apiUrl}/v2/comments/stories/del`,items).then(res => {
                    this.items = this.def_group;
                    if (res.status == 200) {
                        this.$vs.notify({
                            color: 'warning',
                            title: 'Comments Deleted !',
                            text: res.data.response
                        })
                    }
                  this.fetchComments();
                })
        // this.$vs.notify({
        //   color:'danger',
        //   title:'Deleted Comments',
        //   text:`Deleted (${this.selected.length}) item`
        // })
      },
    },
}
</script>
<style lang="css">
    
</style>